import {
  Button,
  Divider,
  message,
  Pagination,
  Popconfirm,
  Table,
  Tag,
} from "antd";
import { useEffect, useState } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ExtractDate, ExtractTime, messageConfiguration } from "../../../Utils";
import { deleteSubscriber, getSubscribers } from "./SubscriberApi";

function Subscriber() {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPages] = useState();
  const [offerData, setOfferData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  function FetchOfferData() {
    setIsLoading(true);
    getSubscribers(
      `?limit=10&page=${currentPage}${
        search && search.length ? `&search=${search}` : ""
      }`
    )
      .then((response) => {
        if (response.status) {
          setIsLoading(false);
          setOfferData(response.data.items);
          setTotalPages(response?.data?.pagination?.lastPage);
          setCurrentPage(response?.data?.pagination?.currentPage);
        }
      })
      .catch((err) => {
        console.log("error", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    FetchOfferData();
  }, [currentPage]);
  function DeleteAction(checked, record) {
    deleteSubscriber(`${record._id}`)
      .then((response) => {
        if (response.status) {
          message.open(messageConfiguration("success", response.message, 3));
          FetchOfferData();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const columns = [
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      className: " font-dmsans text-sm",
      render: (data, record) => (
        <p className="text-xs font-dmsans items-center flex justify-center">
          {record.email}
        </p>
      ),
    },

    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      align: "center",
      className: "font-dmsans text-sm",
      render: (data) => {
        return (
          <div className="flex justify-center">
            <Tag
              className={`text-xs font-dmsans items-center flex justify-center ${
                data
                  ? "bg-[#996600] text-white border-none p-1 w-[80px]"
                  : "bg-[#cecdcd] text-white border-none p-1 w-[80px]"
              }`}
            >
              {data ? "Active" : "Inactive"}
            </Tag>
          </div>
        );
      },
    },
    {
      title: "Created Time",
      dataIndex: "createdAt",
      key: "createdAt",
      className: " font-dmsans text-sm",
      render: (data, record) => (
        <p className="text-xs font-dmsans items-center flex justify-center">
          {ExtractDate(record.createdAt)}.{ExtractTime(record.createdAt)}
        </p>
      ),
    },

    {
      title: "Delete",
      dataIndex: "delete",
      key: "delete",
      className: "font-dmsans text-sm",
      render: (data, record) => (
        <div className="items-center flex justify-center ">
          <Popconfirm
            title={
              <div>
                <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
                  Are you sure you want to delete this Subscriber?
                </p>
              </div>
            }
            onConfirm={() => DeleteAction(undefined, record)}
            okText="Delete"
            cancelText="Cancel"
          >
            <DeleteOutlined className="text-xs font-dmsans" title="Delete" />
          </Popconfirm>
        </div>
      ),
    },
  ];

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
  };

  return (
    <>
      <div className="ml-2  mt-6 mr-2">
        <div className=" mb-8 ">
          <Divider
            orientation="left"
            style={{ border: "#cecece" }}
            className="text-base tracking-normal font-dmsans font-normal  text-gray-900"
          >
            Subscriber Details
          </Divider>
          <div className="flex justify-end items-end gap-3">
            <div>
              <Button
                onClick={() =>
                  navigate("/subscriber/add_subscriber", {
                    state: {
                      fill: null,
                      from: "add",
                    },
                  })
                }
              >
                Add Subscriber
              </Button>
            </div>
          </div>
        </div>

        <div
          style={{ maxHeight: "620px", overflow: "auto" }}
          className="bg-white"
        >
          <Table
            columns={columns}
            dataSource={offerData}
            className="w-screen sm:w-screen"
            loading={isLoading}
            pagination={false}
          />
        </div>
        <Pagination
          className="mt-2  flex justify-center items-center font-inter font-medium text-base w-full  h-[19px] "
          onChange={handlePageChange}
          current={currentPage}
          defaultCurrent={1}
          total={10 * totalPage}
          showSizeChanger={false}
        />
      </div>
    </>
  );
}
export default Subscriber;
